import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDominica = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1918)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.3479 23.7697C19.0918 22.8286 22.8287 19.0917 23.7698 14.3478H14.3479V23.7697Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.230347 14.3478C1.17136 19.0917 4.90833 22.8286 9.65223 23.7697V14.3478H0.230347Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.7698 9.65216C22.8287 4.90832 19.0918 1.17135 14.3479 0.230286V9.65216H23.7698Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.65223 0.230286C4.90833 1.17135 1.17136 4.90832 0.230347 9.65216H9.65223V0.230286Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.2174 14.3478H9.65222V23.7697C10.163 23.871 10.6855 23.9396 11.2174 23.9739V14.3478Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.2174 9.65218V0.026123C10.6855 0.0603418 10.163 0.129014 9.65222 0.23031V9.65218H11.2174Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.7827 0.0261094C12.5238 0.009375 12.263 0 12 0C11.737 0 11.4763 0.009375 11.2174 0.0261094V9.65222H12.7826V0.0261094H12.7827Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.2174 23.9739C11.4763 23.9906 11.737 24 12 24C12.263 24 12.5238 23.9906 12.7827 23.9739V14.3478H11.2175V23.9739H11.2174Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.65218 11.2174V9.65216H0.23031C0.128967 10.163 0.0603418 10.6855 0.026123 11.2174H9.65218Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.3478 11.2174H23.9739C23.9397 10.6855 23.871 10.163 23.7697 9.65216H14.3478V11.2174H14.3478Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.3478 12.7826H23.9739C23.9906 12.5238 24 12.263 24 12C24 11.737 23.9906 11.4762 23.9738 11.2174H14.3478V12.7826Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.0261094 11.2174C0.00942187 11.4762 0 11.737 0 12C0 12.263 0.00942187 12.5238 0.0261094 12.7826H9.65222V11.2174H0.0261094V11.2174Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 17.7391C15.1696 17.7391 17.7391 15.1696 17.7391 12C17.7391 8.83037 15.1696 6.26086 12 6.26086C8.83037 6.26086 6.26086 8.83037 6.26086 12C6.26086 15.1696 8.83037 17.7391 12 17.7391Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.3075 12.6403C12.8806 11.7866 12.3258 10.9213 12.3258 10.9213C12.3258 10.9213 12.3396 10.5273 12.3396 10.2925C12.3396 9.93891 12.0529 9.65222 11.6992 9.65222C11.3642 9.65222 11.0897 9.90961 11.0617 10.2373C10.7983 10.2545 10.5898 10.473 10.5898 10.7408C10.5898 10.9355 10.7001 11.1042 10.8616 11.1885C10.9418 11.0008 11.099 10.8543 11.2933 10.7875C11.325 10.8134 11.359 10.8366 11.3953 10.8562L11.4774 10.8955C11.4774 10.8955 11.1732 11.7529 11.1732 12.2135C11.1732 13.5083 12.027 13.9077 12.027 13.9077V13.921L11.6001 14.3479H12.4538V13.4941L12.8807 13.921C12.8845 13.913 13.6893 13.404 13.3075 12.6403Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 7.30435L12.1942 7.9022H12.8228L12.3143 8.27171L12.5086 8.86955L12 8.50009L11.4914 8.86955L11.6857 8.27171L11.1771 7.9022H11.8057L12 7.30435Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.24 8.20116L9.7485 8.57067L10.2571 8.20111L10.0628 8.79905L10.5714 9.16847L9.9428 9.16852L9.74855 9.76636L9.55425 9.16852L8.92566 9.16847L9.43421 8.79895L9.24 8.20116Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.53418 10.549H8.16273L8.35702 9.95114L8.55127 10.549L9.17991 10.5489L8.67137 10.9185L8.86566 11.5163L8.35702 11.1468L7.84848 11.5163L8.04268 10.9185L7.53418 10.549Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.53418 13.451L8.04268 13.0816L7.84843 12.4837L8.35702 12.8532L8.86562 12.4837L8.67137 13.0815L9.17996 13.4511L8.55127 13.4511L8.35702 14.0489L8.16273 13.451H7.53418Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.24005 15.7989L9.43425 15.2011L8.92566 14.8316H9.5543L9.7486 14.2337L9.94285 14.8315H10.5715L10.0629 15.2011L10.2571 15.7989L9.74855 15.4294L9.24005 15.7989Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 16.6957L11.8057 16.0979H11.1771L11.6857 15.7284L11.4914 15.1305L12 15.4999L12.5085 15.1305L12.3143 15.7284L12.8228 16.0979L12.1942 16.0979L12 16.6957Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.76 15.7989L14.2515 15.4294L13.743 15.799L13.9372 15.2011L13.4286 14.8316L14.0572 14.8315L14.2514 14.2337L14.4458 14.8316H15.0744L14.5658 15.2011L14.76 15.7989Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.4658 13.451H15.8373L15.643 14.0489L15.4488 13.4511H14.8201L15.3287 13.0816L15.1344 12.4838L15.643 12.8532L16.1515 12.4838L15.9573 13.0816L16.4658 13.451Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.4658 10.549L15.9573 10.9185L16.1516 11.5163L15.643 11.1468L15.1344 11.5164L15.3287 10.9185L14.8201 10.549L15.4488 10.549L15.643 9.9512L15.8373 10.549H16.4658Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.76 8.20117L14.5658 8.79897L15.0744 9.16848H14.4458L14.2515 9.76638L14.0572 9.16853L13.4286 9.16858L13.9372 8.79897L13.7429 8.20122L14.2515 8.57064L14.76 8.20117Z",
				fill: "#496E2D"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1918",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgDominica;
